import { documents } from './Documents'
import { users } from './User'

export const resources = [documents, users]
